// ----------------------------------------------------------------------------- //
// 	Update input range
// ----------------------------------------------------------------------------- //
export default function handleInputRangeChange( ref = document ) {

	const inputRange = ref.querySelectorAll('.input-range');

	if ( inputRange.length ) {
		inputRange.forEach( (e) => {

			const minValue = e.getAttribute("min");
			const maxValue = e.getAttribute("max");
			const thumbKnob = e.nextElementSibling.querySelector('.input-range-appearance__thumb-knob');
			const thumbWidth = thumbKnob.offsetWidth;
			const trackFill = e.nextElementSibling.querySelector('.input-range-appearance__track-fill');

			if ( ! trackFill || ! thumbKnob ) return;

			const handleInputChange = ( currentValue ) => {
				const percent = ( currentValue - minValue ) * 100 / ( maxValue - minValue );
				const offset = ( thumbWidth * percent ) / 100;
				thumbKnob.style.left = percent + '%';
				trackFill.style.width = 'calc(' + percent + '%  - ' + offset / 10 + 'rem + ' + thumbWidth / 2 + 'px)';
			}

			handleInputChange( e.value );

			e.addEventListener( "input", (el) => {
				handleInputChange( el.target.value );
			});
		});
	}
};
